// src/components/raios/WizardResumePrompt.tsx
//
// Mostrado quando frontend detecta wizard paused do user (refresh page perdeu state).
// User escolhe: continuar ou começar novo. PR9 (Fase 1.B PR7).

import type { WizardExecution } from '@/lib/api';
import { useNowTick } from '@/hooks/useNowTick';

interface WizardResumePromptProps {
  execution: WizardExecution;
  onContinue: () => void;
  onStartNew: () => void;
}

export function WizardResumePrompt({ execution, onContinue, onStartNew }: WizardResumePromptProps) {
  const now = useNowTick(60_000);
  const minutesAgo = Math.floor(
    (now - new Date(execution.last_activity_at).getTime()) / (60 * 1000),
  );
  return (
    <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 my-4">
      <div className="flex items-start justify-between">
        <div>
          <div className="font-semibold text-yellow-900">Wizard pausado detectado</div>
          <div className="text-sm text-yellow-800 mt-1">
            Você tem um wizard pausado de ~{minutesAgo}min atrás (step: {execution.step ?? 'inicial'}).
            Continuar de onde parou ou começar novo?
          </div>
        </div>
        <div className="flex gap-2 ml-4">
          <button
            onClick={onContinue}
            className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
          >
            Continuar
          </button>
          <button
            onClick={onStartNew}
            className="px-3 py-1 bg-white border border-neutral-300 rounded text-sm hover:bg-neutral-50"
          >
            Começar novo
          </button>
        </div>
      </div>
    </div>
  );
}
